import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const OrderLeadList = () => {
  const [leads, setLeads] = useState([]);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    fetch("https://pbhrm.com/api/oleads")
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 1) {
          setLeads(data.data);
          setFilteredLeads(data.data);
        } else {
          setError("Failed to load leads");
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setError("Error fetching leads");
        console.error("Error fetching leads:", error);
      });
  }, []);

  const formatDate = (date) => {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const openStatusModal = (id) => {
    setSelectedLeadId(id);
    setStatusModalOpen(true);
  };

  const closeStatusModal = () => {
    setStatusModalOpen(false);
  };

  const handleStatusChange = async (status) => {
    try {
      // Try different HTTP methods and endpoints
      const endpoints = [
        {
          url: `https://pbhrm.com/api/oleads/status/${selectedLeadId}`,
          method: "PUT",
        },
        {
          url: `https://pbhrm.com/api/oleads/${selectedLeadId}/status`,
          method: "PUT",
        },
        {
          url: `https://pbhrm.com/api/oleads/status/${selectedLeadId}`,
          method: "PATCH",
        },
        {
          url: `https://pbhrm.com/api/oleads/${selectedLeadId}`,
          method: "PUT",
          body: { status: status },
        },
      ];

      let success = false;
      let responseData = null;

      for (let endpoint of endpoints) {
        try {
          console.log(`Trying: ${endpoint.method} ${endpoint.url}`);

          const response = await fetch(endpoint.url, {
            method: endpoint.method,
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(endpoint.body || { status }),
          });

          // Check if response is JSON
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.includes("application/json")) {
            responseData = await response.json();

            if (responseData.status === 1) {
              success = true;
              break;
            }
          } else {
            const text = await response.text();
            console.log("Non-JSON response:", text.substring(0, 200));
          }
        } catch (err) {
          console.log(
            `Endpoint failed: ${endpoint.method} ${endpoint.url}`,
            err
          );
          continue;
        }
      }

      if (success && responseData) {
        const updatedLeads = leads.map((lead) =>
          lead.id === selectedLeadId
            ? { ...lead, status: responseData.data.status }
            : lead
        );
        setLeads(updatedLeads);
        setFilteredLeads(updatedLeads);
        closeStatusModal();
        alert("Status updated successfully!");
      } else {
        // If all API calls fail, update locally
        const confirmUpdate = window.confirm(
          "API not responding. Update status locally?"
        );

        if (confirmUpdate) {
          const updatedLeads = leads.map((lead) =>
            lead.id === selectedLeadId ? { ...lead, status: status } : lead
          );
          setLeads(updatedLeads);
          setFilteredLeads(updatedLeads);
          closeStatusModal();
          alert("Status updated locally!");
        }
      }
    } catch (error) {
      console.error("Error updating lead status:", error);
      alert("Network error. Please check your connection.");
    }
  };

  const handleSearchChange = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
    filterLeads(term, statusFilter);
  };

  const handleStatusFilterChange = (event) => {
    const status = event.target.value;
    setStatusFilter(status);
    filterLeads(searchTerm, status);
  };

  const filterLeads = (term, status) => {
    const filtered = leads.filter((lead) => {
      const matchesSearch = lead.name
        ?.toLowerCase()
        .includes(term.toLowerCase());
      const matchesStatus = status ? lead.status === status : true;
      return matchesSearch && matchesStatus;
    });
    setFilteredLeads(filtered);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div id="main">
      <header className="mb-3">
        <a href="#" className="burger-btn d-block d-xl-none">
          <i className="bi bi-justify fs-3"></i>
        </a>
      </header>

      <div className="page-heading">
        <div className="page-title">
          <div className="row">
            <div className="col-12 col-md-6 order-md-1 order-last">
              <h3>Order Lead List</h3>
            </div>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="row" id="basic-table">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-6"></div>
                  <div className="col-md-6 text-end">
                    <button
                      className="btn btn-primary"
                      onClick={() => navigate("/AddLead")}
                    >
                      Add Lead
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="mb-3 row">
                  <div className="col-md-6">
                    <label htmlFor="searchTerm" className="form-label">
                      Search by Name
                    </label>
                    <input
                      type="text"
                      id="searchTerm"
                      className="form-control"
                      placeholder="Search by name"
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </div>
                  {/* <div className="col-md-6">
                    <label htmlFor="statusFilter" className="form-label">
                      Status
                    </label>
                    <select
                      id="statusFilter"
                      className="form-control"
                      value={statusFilter}
                      onChange={handleStatusFilterChange}
                    >
                      <option value="">All</option>
                      <option value="pending">Pending</option>
                      <option value="completed">Completed</option>
                    </select>
                  </div> */}
                </div>

                <div className="table-responsive">
                  <table className="table table-lg">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th className="text-end">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredLeads.map((lead) => (
                        <tr key={lead.id}>
                          <td>{lead.name || "N/A"}</td>
                          <td>{lead.number || "N/A"}</td>
                          <td>{lead.description || "N/A"}</td>
                          <td>
                            <span
                              className={`badge ${
                                lead.status === "completed"
                                  ? "bg-success"
                                  : "bg-warning"
                              }`}
                            >
                              {lead.status || "N/A"}
                            </span>
                          </td>
                          <td className="text-end">
                            <button
                              className="btn btn-warning"
                              onClick={() => openStatusModal(lead.id)}
                            >
                              Change Status
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {statusModalOpen && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Change Lead Status</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeStatusModal}
                ></button>
              </div>
              <div className="modal-body text-center">
                <button
                  className="btn btn-success me-3"
                  onClick={() => handleStatusChange("completed")}
                >
                  Completed
                </button>
                <button
                  className="btn btn-warning"
                  onClick={() => handleStatusChange("pending")}
                >
                  Pending
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderLeadList;
